import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09410354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "txt" }
const _hoisted_2 = { class: "txt" }
const _hoisted_3 = { class: "calendar-event-title" }
const _hoisted_4 = { class: "label-form" }
const _hoisted_5 = { class: "label-form" }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "label-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-icon" }, "*", -1))
const _hoisted_9 = { class: "label label-form" }
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = { class: "label-form" }
const _hoisted_14 = {
  key: 0,
  class: "error-message"
}
const _hoisted_15 = { class: "label-form" }
const _hoisted_16 = { class: "label-container check-container" }
const _hoisted_17 = { class: "label label-form" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "check-container" }
const _hoisted_20 = { class: "period-config" }
const _hoisted_21 = {
  key: 0,
  class: "periodicty-label"
}
const _hoisted_22 = { class: "periodicty-label" }
const _hoisted_23 = { class: "periodicty-label" }
const _hoisted_24 = {
  key: 0,
  class: "error-container error-message"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "periodicty-label" }
const _hoisted_27 = { class: "periodicty-label" }
const _hoisted_28 = { class: "check-container" }
const _hoisted_29 = { class: "period-config" }
const _hoisted_30 = {
  key: 0,
  class: "periodicty-label"
}
const _hoisted_31 = { class: "periodicty-label" }
const _hoisted_32 = { class: "periodicty-label" }
const _hoisted_33 = {
  key: 0,
  class: "error-container error-message"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "display-container" }
const _hoisted_36 = { class: "periodicty-label" }
const _hoisted_37 = { class: "periodicty-label" }
const _hoisted_38 = { class: "period-container" }
const _hoisted_39 = { class: "periodicty-label" }
const _hoisted_40 = {
  key: 0,
  class: "error-container error-message"
}
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { class: "periodicty-label" }
const _hoisted_43 = { class: "periodicty-label" }
const _hoisted_44 = { class: "display" }
const _hoisted_45 = { class: "periodicty-label" }
const _hoisted_46 = {
  key: 0,
  class: "error-container error-message"
}
const _hoisted_47 = {
  key: 0,
  class: "periodical-error"
}
const _hoisted_48 = {
  key: 1,
  class: "periodical-success"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "label-form" }
const _hoisted_52 = { class: "label-form" }
const _hoisted_53 = { class: "label-form" }
const _hoisted_54 = { class: "label-form" }
const _hoisted_55 = { class: "drawer-title" }
const _hoisted_56 = { class: "info-title" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "mr-l info-txt" }
const _hoisted_59 = {
  key: 0,
  class: "info-txt"
}
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "info-txt" }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "periodicty-label mr-l info-txt" }
const _hoisted_64 = {
  key: 0,
  class: "periodicty-label info-txt number"
}
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "periodicty-label info-txt" }
const _hoisted_67 = { class: "periodicty-label" }
const _hoisted_68 = { key: 2 }
const _hoisted_69 = { class: "periodicty-label mr-l info-txt" }
const _hoisted_70 = { class: "periodicty-label info-txt" }
const _hoisted_71 = { class: "periodicty-label info-txt number" }
const _hoisted_72 = { class: "periodicty-label info-txt" }
const _hoisted_73 = { key: 3 }
const _hoisted_74 = { class: "periodicty-label mr-l info-txt" }
const _hoisted_75 = { class: "periodicty-label info-txt" }
const _hoisted_76 = { class: "periodicty-label info-txt number" }
const _hoisted_77 = { class: "periodicty-label info-txt" }
const _hoisted_78 = { class: "info-title" }
const _hoisted_79 = { class: "info-txt" }
const _hoisted_80 = { class: "info-title" }
const _hoisted_81 = { class: "start-date info-txt" }
const _hoisted_82 = { class: "info-txt" }
const _hoisted_83 = { class: "info-title" }
const _hoisted_84 = { class: "info-txt" }
const _hoisted_85 = { class: "info-title" }
const _hoisted_86 = { class: "info-txt" }
const _hoisted_87 = { class: "info-title" }
const _hoisted_88 = { class: "info-txt" }
const _hoisted_89 = { class: "info-txt" }
const _hoisted_90 = { class: "info-title" }
const _hoisted_91 = { class: "info-txt" }
const _hoisted_92 = { class: "info-txt" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "info-title" }
const _hoisted_96 = { class: "info-txt" }
const _hoisted_97 = { class: "info-txt" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "label-form" }
const _hoisted_101 = { class: "label-form" }
const _hoisted_102 = { class: "label-container" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-icon" }, "*", -1))
const _hoisted_104 = { class: "label label-form" }
const _hoisted_105 = { class: "label-form" }
const _hoisted_106 = { class: "label-form" }
const _hoisted_107 = { class: "label-container check-container" }
const _hoisted_108 = { class: "label label-form" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { class: "check-container" }
const _hoisted_111 = { class: "period-config" }
const _hoisted_112 = {
  key: 0,
  class: "periodicty-label"
}
const _hoisted_113 = { class: "periodicty-label" }
const _hoisted_114 = { class: "periodicty-label" }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { class: "display-container" }
const _hoisted_117 = { class: "periodicty-label" }
const _hoisted_118 = { class: "periodicty-label" }
const _hoisted_119 = { class: "check-container" }
const _hoisted_120 = { class: "period-config display-container" }
const _hoisted_121 = {
  key: 0,
  class: "periodicty-label"
}
const _hoisted_122 = { class: "periodicty-label" }
const _hoisted_123 = { class: "periodicty-label" }
const _hoisted_124 = { key: 2 }
const _hoisted_125 = { class: "display-container" }
const _hoisted_126 = { class: "periodicty-label" }
const _hoisted_127 = { class: "period-container display" }
const _hoisted_128 = { class: "periodicty-label" }
const _hoisted_129 = { key: 3 }
const _hoisted_130 = { class: "display-container" }
const _hoisted_131 = { class: "periodicty-label" }
const _hoisted_132 = { class: "periodicty-label" }
const _hoisted_133 = { class: "display" }
const _hoisted_134 = { class: "periodicty-label" }
const _hoisted_135 = ["disabled"]
const _hoisted_136 = {
  key: 0,
  class: "periodical-error"
}
const _hoisted_137 = {
  key: 1,
  class: "periodical-success"
}
const _hoisted_138 = { key: 0 }
const _hoisted_139 = { key: 1 }
const _hoisted_140 = { class: "btns-container" }
const _hoisted_141 = { class: "invite-user-container" }
const _hoisted_142 = { class: "modal-title" }
const _hoisted_143 = { class: "label-form" }
const _hoisted_144 = { class: "label-container" }
const _hoisted_145 = { class: "txt-form" }
const _hoisted_146 = { class: "btns-container" }
const _hoisted_147 = { class: "invite-user-container" }
const _hoisted_148 = { class: "modal-title" }
const _hoisted_149 = { class: "label-form" }
const _hoisted_150 = { class: "label-form" }
const _hoisted_151 = { class: "label-form" }
const _hoisted_152 = { class: "btns-container" }
const _hoisted_153 = { class: "invite-user-container" }
const _hoisted_154 = { class: "modal-title" }
const _hoisted_155 = { class: "label-form" }
const _hoisted_156 = { class: "label-form" }
const _hoisted_157 = { class: "label-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_ScheduleOutlined = _resolveComponent("ScheduleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_locale_provider = _resolveComponent("a-locale-provider")!
  const _component_a_time_picker = _resolveComponent("a-time-picker")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_check_circle_two_tone = _resolveComponent("check-circle-two-tone")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_close_circle_two_tone = _resolveComponent("close-circle-two-tone")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_check_circle_outlined = _resolveComponent("check-circle-outlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_CloseCircleOutlined = _resolveComponent("CloseCircleOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_TeamOutlined = _resolveComponent("TeamOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Loader, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, { style: {"margin":"16px 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.t('Meet.Dashboard')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t('Meet.Meetings')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.state.userRole === 'ADMIN' || _ctx.state.userRole === 'MANAGER' )
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          class: "btn-container",
          gutter: 16
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: { span: 24},
              sm: { span: 24},
              md: {span: 12},
              lg: { span: 12 },
              xl: { span: 12 },
              xxl: { span: 12 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filtredRoom,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtredRoom) = $event)),
                  style: {"width":"100%"},
                  placeholder: _ctx.t('Meet.filterResTxt'),
                  "show-search": "",
                  "option-filter-prop": 'label',
                  onChange: _ctx.getReservationsRoom,
                  allowClear: ""
                }, {
                  notFoundContent: _withCtx(() => [
                    _createVNode(_component_a_empty, {
                      description: _ctx.t('Meet.NoData'),
                      image: _ctx.simpleImage
                    }, null, 8, ["description", "image"])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.rooms, (room) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: room.id,
                        value: room.id,
                        label: room.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(room.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "placeholder", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              class: "add-btn-container",
              xs: { span: 24},
              sm: { span: 24},
              md: {span: 12},
              lg: { span: 12 },
              xl: { span: 12 },
              xxl: { span: 12 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "add-btn",
                  onClick: _ctx.showAddDrawer
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_ScheduleOutlined)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('Meet.Add')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_FullCalendar, {
        ref: "calendarRef",
        options: _ctx.calendarOptions
      }, {
        eventContent: _withCtx((arg) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(arg.event.title), 1)
          ])
        ]),
        _: 1
      }, 8, ["options"])
    ]),
    _createVNode(_component_a_drawer, {
      open: _ctx.openAdd,
      "onUpdate:open": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.openAdd) = $event)),
      class: "custom-class",
      "root-class-name": "root-class-name",
      placement: _ctx.locale === 'ar' ? 'left' : 'right',
      width: _ctx.modalWidth,
      onClose: _ctx.resetFormAdd
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", {
          class: _normalizeClass(["drawer-title", { 'is-rtl': _ctx.textDirection==='rtl'}])
        }, _toDisplayString(_ctx.t('Meet.AddMeeting')), 3)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              disabled: _ctx.checkedPeriodicity && !_ctx.state.periodical,
              type: "primary",
              onClick: _ctx.addReservation
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Meet.Add')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              danger: "",
              onClick: _ctx.resetFormAdd
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "addFormRef",
          model: _ctx.addForm,
          rules: _ctx.formRules,
          layout: "vertical",
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "motif" }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, null, {
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Meet.motifTxt')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_QuestionCircleOutlined, {
                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                            }, null, 8, ["class"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('Meet.Motif')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.addForm.motif,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addForm.motif) = $event)),
                          placeholder: _ctx.t('Meet.Motif'),
                          class: "input-form"
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "room_id" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('Meet.Room')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.addForm.room_id,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addForm.room_id) = $event)),
                          "show-search": "",
                          "option-filter-prop": 'label',
                          onSelect: _ctx.getSelectedRoom,
                          class: _normalizeClass({'error-border': _ctx.state.validationErrors.room_id})
                        }, {
                          notFoundContent: _withCtx(() => [
                            _createVNode(_component_a_empty, {
                              description: _ctx.t('Meet.NoData'),
                              image: _ctx.simpleImage
                            }, null, 8, ["description", "image"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.rooms, (room) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                label: room.name,
                                key: room.id,
                                value: room.id,
                                selected: room.id === _ctx.addForm.room_id 
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(room.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value", "selected"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "onSelect", "class"]),
                        (_ctx.state.validationErrors.room_id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Meet.ReservationTime')), 1)
                    ]),
                    _createVNode(_component_a_row, { gutter: 16 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { name: "dateMeet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_date_picker, {
                                      id: "dateMeet",
                                      value: _ctx.addForm.dateMeet,
                                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addForm.dateMeet) = $event)),
                                      class: _normalizeClass(["date-picker-date", {'error-border': _ctx.state.validationErrors.dateMeet}]),
                                      "disabled-date": _ctx.disableDates,
                                      disabled: !_ctx.addForm.room_id
                                    }, null, 8, ["value", "disabled-date", "disabled", "class"])
                                  ]),
                                  _: 1
                                }, 8, ["locale"]),
                                (_ctx.state.validationErrors.dateMeet)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { name: "startTime" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_time_picker, {
                                  id: "sartTime",
                                  value: _ctx.addForm.startTime,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addForm.startTime) = $event)),
                                  format: "HH:mm",
                                  class: _normalizeClass(["date-picker-date", {'error-border': _ctx.state.validationErrors.startTime}]),
                                  "minute-step": 5,
                                  showNow: false,
                                  "disabled-hours": _ctx.disableWDdHours,
                                  "hide-disabled-options": true,
                                  disabled: !_ctx.addForm.dateMeet || !_ctx.addForm.room_id,
                                  onChange: _ctx.handleStartTime
                                }, null, 8, ["value", "disabled-hours", "disabled", "onChange", "class"]),
                                (_ctx.state.validationErrors.startTime)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { name: "durationTime" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_time_picker, {
                                  id: "duration",
                                  value: _ctx.addForm.durationTime,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addForm.durationTime) = $event)),
                                  format: "HH:mm",
                                  class: _normalizeClass(["date-picker-date", {'error-border': _ctx.state.validationErrors.durationTime}]),
                                  "minute-step": 5,
                                  placeholder: "Select duration",
                                  "disabled-hours": _ctx.disableDurationHours,
                                  "disabled-minutes": _ctx.disableDurationMinutes,
                                  "hide-disabled-options": true,
                                  showNow: false,
                                  disabled: !_ctx.addForm.startTime,
                                  onSelect: _ctx.handleDurationPicker
                                }, null, 8, ["value", "disabled-hours", "disabled-minutes", "disabled", "onSelect", "class"]),
                                (_ctx.state.validationErrors.durationTime)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "participants" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('Meet.Participants')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          id: "participants",
                          value: _ctx.state.value,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.value) = $event)),
                          mode: "multiple",
                          "label-in-value": "",
                          placeholder: _ctx.t('Meet.selectParticipants'),
                          style: {"width":"100%"},
                          "filter-option": false,
                          "not-found-content": _ctx.state.fetching ? undefined : null,
                          options: _ctx.state.users,
                          onSearch: _ctx.fetchUser,
                          onChange: _ctx.handleUsersSelect,
                          class: _normalizeClass({'error-border': _ctx.state.validationErrors.participants})
                        }, _createSlots({ _: 2 }, [
                          (_ctx.state.fetching)
                            ? {
                                name: "notFoundContent",
                                fn: _withCtx(() => [
                                  _createVNode(_component_a_spin, { size: "small" })
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["value", "placeholder", "not-found-content", "options", "onSearch", "onChange", "class"]),
                        (_ctx.state.validationErrors.participants)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "notifMail" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('Meet.notifMailContent')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.addForm.notifMail,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addForm.notifMail) = $event)),
                          rows: 4,
                          placeholder: _ctx.t('Meet.notifMailContent')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { class: "periodicty-container" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_a_switch, {
                        checked: _ctx.checkedPeriodicity,
                        "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkedPeriodicity) = $event)),
                        class: "check-btn"
                      }, null, 8, ["checked"]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('Meet.periodicity')), 1)
                    ]),
                    (_ctx.checkedPeriodicity === true)
                      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 9 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_group, {
                                  value: _ctx.periodicity,
                                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.periodicity) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "daily"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Daily')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "weekly"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.weekly')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "monthly"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.monthly')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "yearly"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.annual')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"])
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 15 }, {
                              default: _withCtx(() => [
                                (_ctx.periodicity ===  'daily' )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _ctx.weeklyConf,
                                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.weeklyConf) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, { value: "Monday" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Monday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, { value: "Tuesday" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Tuesday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, { value: "Wednesday" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Wednesday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, { value: "Thursday" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Thursday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, { value: "Friday" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Friday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, { value: "Saturday" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Saturday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, { value: "Sunday" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Sunday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _createElementVNode("div", _hoisted_20, [
                                        (_ctx.weeklyConf.length === 7)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.t('Meet.MeetingEvery')) + " " + _toDisplayString(_ctx.t('Meet.everyday')), 1))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('Meet.MeetingEvery')), 1),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyConf, (day) => {
                                                return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(_ctx.translateDay(day)) + " , ", 1))
                                              }), 128))
                                            ], 64)),
                                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_date_picker, {
                                              id: "periodEnDate",
                                              value: _ctx.addForm.periodEndDate,
                                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addForm.periodEndDate) = $event)),
                                              class: "period-date",
                                              "disabled-date": _ctx.disablePeriodDates,
                                              disabled: _ctx.weeklyConf.length===0,
                                              style: _normalizeStyle({'border': _ctx.state.validationErrors.periodEndDate ? '2px solid red' : ''})
                                            }, null, 8, ["value", "disabled-date", "disabled", "style"]),
                                            (_ctx.state.validationErrors.periodEndDate)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["locale"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.periodicity ===  'weekly' )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.weeklyTxt')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.t('Meet.every')), 1),
                                        _createVNode(_component_a_input, {
                                          value: _ctx.addForm.periodicity,
                                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addForm.periodicity) = $event)),
                                          class: "periodicity-input"
                                        }, null, 8, ["value"]),
                                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t('Meet.week')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _ctx.weeklyConf,
                                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.weeklyConf) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Monday",
                                                      disabled: !_ctx.addForm.periodicity
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Monday')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Tuesday",
                                                      disabled: !_ctx.addForm.periodicity
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Tuesday')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Wednesday",
                                                      disabled: !_ctx.addForm.periodicity
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Wednesday')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Thursday",
                                                      disabled: !_ctx.addForm.periodicity
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Thursday')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Friday",
                                                      disabled: !_ctx.addForm.periodicity
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Friday')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Saturday",
                                                      disabled: !_ctx.addForm.periodicity
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Saturday')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Sunday",
                                                      disabled: !_ctx.addForm.periodicity
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Sunday')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _createElementVNode("div", _hoisted_29, [
                                        (_ctx.weeklyConf.length === 7)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.t('Meet.MeetingEvery')) + " " + _toDisplayString(_ctx.t('Meet.everyday')), 1))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.t('Meet.MeetingEvery')), 1),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyConf, (day) => {
                                                return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(_ctx.translateDay(day)) + " , ", 1))
                                              }), 128))
                                            ], 64)),
                                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_form_item, { name: "periodEndDate" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_date_picker, {
                                                  id: "periodEnDate",
                                                  value: _ctx.addForm.periodEndDate,
                                                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addForm.periodEndDate) = $event)),
                                                  class: _normalizeClass(["period-date", {'error-border': _ctx.state.validationErrors.periodEndDate}]),
                                                  "disabled-date": _ctx.disablePeriodDates,
                                                  disabled: _ctx.weeklyConf.length===0
                                                }, null, 8, ["value", "disabled-date", "disabled", "class"]),
                                                (_ctx.state.validationErrors.periodEndDate)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }, 8, ["locale"])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.periodicity ===  'monthly' )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.monthlyTxt')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.t('Meet.ofEvery')), 1),
                                        _createVNode(_component_a_input, {
                                          value: _ctx.addForm.periodicity,
                                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addForm.periodicity) = $event)),
                                          class: "periodicity-input"
                                        }, null, 8, ["value"]),
                                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.t('Meet.Month')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_date_picker, {
                                              id: "periodEnDate",
                                              value: _ctx.addForm.periodEndDate,
                                              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.addForm.periodEndDate) = $event)),
                                              class: _normalizeClass(["period-date", {'error-border': _ctx.state.validationErrors.periodEndDate}]),
                                              "disabled-date": _ctx.disablePeriodDates,
                                              disabled: !_ctx.addForm.periodicity
                                            }, null, 8, ["value", "disabled-date", "disabled", "class"]),
                                            (_ctx.state.validationErrors.periodEndDate)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["locale"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.periodicity === 'yearly')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.annualTxt')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.t('Meet.every')), 1),
                                        _createVNode(_component_a_input, {
                                          value: _ctx.addForm.periodicity,
                                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addForm.periodicity) = $event)),
                                          class: "periodicity-input"
                                        }, null, 8, ["value"]),
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.t('Meet.year')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_date_picker, {
                                              id: "periodEnDate",
                                              value: _ctx.addForm.periodEndDate,
                                              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.addForm.periodEndDate) = $event)),
                                              class: _normalizeClass(["period-date", {'error-border': _ctx.state.validationErrors.periodEndDate}]),
                                              "disabled-date": _ctx.disablePeriodDates
                                            }, null, 8, ["value", "disabled-date", "class"]),
                                            (_ctx.state.validationErrors.periodEndDate)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.t('Meet.RequiredField')), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["locale"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.checkedPeriodicity === true )
              ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 5 }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "availibility-btn",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.checkAvailability()))
                        }, _toDisplayString(_ctx.t('Meet.CheckAvailibility')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 19 }, {
                      default: _withCtx(() => [
                        (_ctx.state.beginCheck  === true)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.state.periodical===false)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                    _createTextVNode(_toDisplayString(_ctx.t('Meet.periodicalError')) + ", ", 1),
                                    _createElementVNode("span", {
                                      class: "discover-title",
                                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.openDiscover && _ctx.openDiscover(...args)))
                                    }, _toDisplayString(_ctx.t('Meet.discover')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.periodical===true && _ctx.state.displaySucees === true )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                    _createVNode(_component_check_circle_two_tone, { "two-tone-color": "#52c41a" }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.periodicalSuccess')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.openSlots && _ctx.checkedPeriodicity === true  && _ctx.state.periodical===false)
              ? (_openBlock(), _createBlock(_component_a_row, {
                  key: 1,
                  gutter: 16
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addForm.AllSlots, (slot, index) => {
                      return (_openBlock(), _createBlock(_component_a_descriptions, {
                        key: index,
                        bordered: "",
                        size: "small",
                        class: _normalizeClass(["mr", [_ctx.locale === 'ar' ? 'ingredient-des-rtl' : 'ingredient-des']])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slot.availability, (availability, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                              _createVNode(_component_a_descriptions_item, {
                                label: _ctx.t('Meet.Date'),
                                span: 3
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(slot.date) + " - " + _toDisplayString(availability.slot), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _createVNode(_component_a_descriptions_item, {
                                label: _ctx.t('Meet.Available')
                              }, {
                                default: _withCtx(() => [
                                  (availability.active === 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                        _createVNode(_component_check_circle_two_tone, { "two-tone-color": "#52c41a" })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (availability.active === 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                                        _createVNode(_component_close_circle_two_tone, { "two-tone-color": "#ff4d4f" })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ], 64))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "equipmenets" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.t('Meet.Equipements')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.addForm.equipmenets,
                          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.addForm.equipmenets) = $event)),
                          mode: "multiple",
                          style: {"width":"100%"},
                          placeholder: _ctx.t('Meet.Equipements'),
                          options: _ctx.options,
                          onChange: _ctx.handleMultiChange,
                          "show-search": "",
                          "option-filter-prop": 'label'
                        }, {
                          notFoundContent: _withCtx(() => [
                            _createVNode(_component_a_empty, {
                              description: _ctx.t('Meet.NoData'),
                              image: _ctx.simpleImage
                            }, null, 8, ["description", "image"])
                          ]),
                          _: 1
                        }, 8, ["value", "placeholder", "options", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.qtArray, (item) => {
              return (_openBlock(), _createBlock(_component_a_row, {
                key: item,
                gutter: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(item.item_name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: 'item' + item.item_id,
                        "validate-status": _ctx.getValidatingStatusQT(item.item_id,'item'),
                        help: _ctx.getValidatingHelpQT(item.item_id,'item')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            id: 'item' + item.item_id,
                            placeholder: _ctx.t('Meet.Quantity'),
                            class: "input-form"
                          }, null, 8, ["id", "placeholder"])
                        ]),
                        _: 2
                      }, 1032, ["name", "validate-status", "help"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "services" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.t('Meet.Services')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.addForm.services,
                          "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.addForm.services) = $event)),
                          mode: "multiple",
                          style: {"width":"100%"},
                          placeholder: _ctx.t('Meet.Services'),
                          options: _ctx.optionServices,
                          onChange: _ctx.handleMultiChangeServices,
                          "show-search": "",
                          "option-filter-prop": 'label'
                        }, {
                          notFoundContent: _withCtx(() => [
                            _createVNode(_component_a_empty, {
                              description: _ctx.t('Meet.NoData'),
                              image: _ctx.simpleImage
                            }, null, 8, ["description", "image"])
                          ]),
                          _: 1
                        }, 8, ["value", "placeholder", "options", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.qtsArray, (item) => {
              return (_openBlock(), _createBlock(_component_a_row, {
                key: item,
                gutter: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_54, _toDisplayString(item.item_name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: 'itemS' + item.item_id,
                        "validate-status": _ctx.getValidatingStatusQT(item.item_id,'itemS'),
                        help: _ctx.getValidatingHelpQT(item.item_id,'itemS')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            id: 'itemS' + item.item_id,
                            placeholder: _ctx.t('Meet.Quantity'),
                            class: "input-form"
                          }, null, 8, ["id", "placeholder"])
                        ]),
                        _: 2
                      }, 1032, ["name", "validate-status", "help"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["model", "rules", "class"])
      ]),
      _: 1
    }, 8, ["open", "placement", "width", "onClose"]),
    _createVNode(_component_a_drawer, {
      open: _ctx.openDisplay,
      "onUpdate:open": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.openDisplay) = $event)),
      class: "custom-class",
      "root-class-name": "root-class-name",
      placement: _ctx.locale === 'ar' ? 'left' : 'right',
      width: _ctx.modalWidth
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", {
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.t('Meet.MeetingInformation')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 12,
                class: "approve-tag-container"
              }, {
                default: _withCtx(() => [
                  (_ctx.form.approved ===true )
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_check_circle_outlined)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Approved')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.approved ===false)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_CloseCircleOutlined)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Disapproved')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 2)
      ]),
      default: _withCtx(() => [
        (_ctx.form.isPeriodic === true)
          ? (_openBlock(), _createBlock(_component_a_row, {
              key: 0,
              gutter: 16,
              class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  class: "periodicity-display-container",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.t('Meet.periodicity')) + " :", 1),
                    (_ctx.periodicity === 'daily' )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.t(`Meet.${_ctx.periodicity}`)), 1),
                          (_ctx.weeklyConfUpdate.length === 7)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.t('Meet.everyday')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_60, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["info-txt", [_ctx.locale === 'ar' ? 'ml' : 'ml']])
                                }, _toDisplayString(_ctx.t('Meet.every')), 3),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyConfUpdate, (day) => {
                                  return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(_ctx.translateDay(day)) + " , ", 1))
                                }), 128))
                              ])),
                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.t('Meet.until')) + " " + _toDisplayString(_ctx.form.periodEndDateFormatted), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.periodicity === 'weekly' )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.t(`Meet.${_ctx.periodicity}`)), 1),
                          (_ctx.weeklyConf.length === 7)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.t('Meet.MeetingEvery')) + " " + _toDisplayString(_ctx.t('Meet.everyday')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_65, [
                                _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.t('Meet.MeetingEvery')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyConf, (day) => {
                                  return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(_ctx.translateDay(day)) + " , ", 1))
                                }), 128))
                              ])),
                          _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.t('Meet.until')) + " " + _toDisplayString(_ctx.form.periodEndDateFormatted), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.periodicity ===  'monthly' )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.t(`Meet.${_ctx.periodicity}`)), 1),
                          _createTextVNode(),
                          _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.t('Meet.Meeting')) + " " + _toDisplayString(_ctx.t('Meet.every')), 1),
                          _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.form.periodicity) + " " + _toDisplayString(_ctx.t('Meet.Month')), 1),
                          _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.t('Meet.until')) + " " + _toDisplayString(_ctx.form.periodEndDateFormatted), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.periodicity ===  'yearly' )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.t(`Meet.${_ctx.periodicity}`)), 1),
                          _createTextVNode(),
                          _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.t('Meet.Meeting')) + " " + _toDisplayString(_ctx.t('Meet.every')), 1),
                          _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.form.periodicity) + " " + _toDisplayString(_ctx.t('Meet.year')), 1),
                          _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.t('Meet.until')) + " " + _toDisplayString(_ctx.form.periodEndDateFormatted), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_row, {
          gutter: 16,
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.t('Meet.Motif')) + " :", 1),
                  _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.form.motif), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_a_row, {
          gutter: 16,
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.t('Meet.Date')) + " :", 1),
                  _createTextVNode(_toDisplayString(_ctx.formatDisplatyDate(_ctx.form.start)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["info-title info-txt", [_ctx.locale === 'ar' ? 'mr' : 'ml']])
                  }, _toDisplayString(_ctx.t('Meet.from')), 3),
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.extractTime(_ctx.form.start)), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["info-title info-txt", [_ctx.locale === 'ar' ? 'mr' : 'ml']])
                  }, _toDisplayString(_ctx.t('Meet.to')), 3),
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.extractTime(_ctx.form.end)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_a_row, {
          gutter: 16,
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.t('Meet.Room')) + " :", 1),
                  _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.form.room_name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.t('Meet.CreatedBy')) + " :", 1),
                  _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.form.created_by_name), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        (_ctx.particpants_array.length !== 0 || _ctx.external_participants.length !== 0)
          ? (_openBlock(), _createBlock(_component_a_row, {
              key: 1,
              class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, [
                      _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.t('Meet.Participants')) + " :", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.particpants_array, (item) => {
          return (_openBlock(), _createBlock(_component_a_row, {
            key: item,
            class: _normalizeClass([_ctx.locale === 'ar' ? 'list-item-container-rtl' : 'list-item-container'])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { flex: "25px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_avatar, { style: {"color":"#f56a00","background-color":"#fde3cf"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getFirstLetter(item.name)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_col, { flex: "auto" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: _normalizeClass([_ctx.locale === 'ar' ? 'title-list-rtl' : 'title-list'])
                  }, [
                    _createElementVNode("span", _hoisted_88, _toDisplayString(item.name), 1)
                  ], 2)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.external_participants, (item) => {
          return (_openBlock(), _createBlock(_component_a_row, {
            key: item,
            class: _normalizeClass([_ctx.locale === 'ar' ? 'list-item-container-rtl' : 'list-item-container'])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { flex: "50px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_avatar, null, {
                    icon: _withCtx(() => [
                      _createVNode(_component_UserOutlined)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { flex: "auto" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: _normalizeClass([_ctx.locale === 'ar' ? 'title-list-rtl' : 'title-list'])
                  }, [
                    _createElementVNode("span", _hoisted_89, _toDisplayString(item.email), 1)
                  ], 2)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128)),
        (_ctx.equipmenets_array.length !== 0)
          ? (_openBlock(), _createBlock(_component_a_row, {
              key: 2,
              class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, [
                      _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.t('Meet.Equipements')) + " :", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmenets_array, (item) => {
          return (_openBlock(), _createBlock(_component_a_descriptions, {
            key: item,
            bordered: "",
            size: "small",
            class: _normalizeClass([_ctx.locale === 'ar' ? 'ingredient-des-rtl' : 'ingredient-des'])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, {
                label: _ctx.t('Meet.Name'),
                span: 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_91, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["label"]),
              _createVNode(_component_a_descriptions_item, {
                label: _ctx.t('Meet.Quantity')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_92, _toDisplayString(item.qte), 1)
                ]),
                _: 2
              }, 1032, ["label"]),
              _createVNode(_component_a_descriptions_item, {
                label: _ctx.t('Meet.Approved')
              }, {
                default: _withCtx(() => [
                  (item.approved===1 || item.approved===true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_93, [
                        _createVNode(_component_check_circle_two_tone, { "two-tone-color": "#52c41a" })
                      ]))
                    : _createCommentVNode("", true),
                  (item.approved===0 || item.approved===false)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, [
                        _createVNode(_component_close_circle_two_tone, { "two-tone-color": "#ff4d4f" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128)),
        (_ctx.services_array.length !== 0)
          ? (_openBlock(), _createBlock(_component_a_row, {
              key: 3,
              class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, [
                      _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.t('Meet.Services')) + " :", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services_array, (item) => {
          return (_openBlock(), _createBlock(_component_a_descriptions, {
            key: item,
            bordered: "",
            size: "small",
            class: _normalizeClass([_ctx.locale === 'ar' ? 'ingredient-des-rtl' : 'ingredient-des'])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, {
                label: _ctx.t('Meet.Name'),
                span: 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_96, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["label"]),
              _createVNode(_component_a_descriptions_item, {
                label: _ctx.t('Meet.Quantity')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_97, _toDisplayString(item.qte), 1)
                ]),
                _: 2
              }, 1032, ["label"]),
              _createVNode(_component_a_descriptions_item, {
                label: _ctx.t('Meet.Approved')
              }, {
                default: _withCtx(() => [
                  (item.approved===1 || item.approved===true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_98, [
                        _createVNode(_component_check_circle_two_tone, { "two-tone-color": "#52c41a" })
                      ]))
                    : _createCommentVNode("", true),
                  (item.approved===0 || item.approved===false)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_99, [
                        _createVNode(_component_close_circle_two_tone, { "two-tone-color": "#ff4d4f" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["open", "placement", "width"]),
    _createVNode(_component_a_drawer, {
      open: _ctx.open,
      "onUpdate:open": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.open) = $event)),
      class: "custom-class",
      "root-class-name": "root-class-name",
      placement: _ctx.locale === 'ar' ? 'left' : 'right',
      width: _ctx.modalWidth,
      onClose: _ctx.cancelUpdate
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", {
          class: _normalizeClass(["drawer-title", { 'is-rtl': _ctx.textDirection==='rtl'}])
        }, _toDisplayString(_ctx.t('Meet.UpdateMeeting')), 3)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.update(_ctx.form.id)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Meet.Update')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.cancelUpdate,
              danger: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.rules,
          layout: "vertical",
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "motif" }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, null, {
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Meet.motifTxt')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_QuestionCircleOutlined, {
                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                            }, null, 8, ["class"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.t('Meet.Motif')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.form.motif,
                          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.motif) = $event)),
                          placeholder: _ctx.t('Meet.Motif'),
                          class: "input-form"
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "room_id" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.t('Meet.Room')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.form.room_id,
                          "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.room_id) = $event)),
                          "show-search": "",
                          "option-filter-prop": 'label'
                        }, {
                          notFoundContent: _withCtx(() => [
                            _createVNode(_component_a_empty, {
                              description: _ctx.t('Meet.NoData'),
                              image: _ctx.simpleImage
                            }, null, 8, ["description", "image"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.rooms, (room) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                label: room.name,
                                key: room.id,
                                value: room.id,
                                selected: room.id === _ctx.form.room_id 
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(room.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value", "selected"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_102, [
                      _hoisted_103,
                      _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.t('Meet.ReservationTime')), 1)
                    ]),
                    _createVNode(_component_a_row, { gutter: 16 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { name: "dateMeet" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_date_picker, {
                                      value: _ctx.form.dateMeet,
                                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.dateMeet) = $event)),
                                      class: "date-picker-date",
                                      "disabled-date": _ctx.disableDates,
                                      disabled: !_ctx.form.room_id
                                    }, null, 8, ["value", "disabled-date", "disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["locale"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { name: "startTime" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_time_picker, {
                                  value: _ctx.form.startTime,
                                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.startTime) = $event)),
                                  format: "HH:mm",
                                  class: "date-picker-date",
                                  "minute-step": 5,
                                  showNow: false,
                                  "disabled-hours": _ctx.disableWDdHours,
                                  "hide-disabled-options": true,
                                  disabled: !_ctx.form.dateMeet  || !_ctx.form.room_id,
                                  onChange: _ctx.handleStartTimeUpdate
                                }, null, 8, ["value", "disabled-hours", "disabled", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { name: "durationTime" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_time_picker, {
                                  value: _ctx.form.durationTime,
                                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.durationTime) = $event)),
                                  format: "HH:mm",
                                  class: "date-picker-date",
                                  "minute-step": 5,
                                  placeholder: "Select duration",
                                  "disabled-hours": _ctx.disableDurationHoursUpdate,
                                  "disabled-minutes": _ctx.disableDurationMinutesUpdate,
                                  "hide-disabled-options": true,
                                  showNow: false,
                                  disabled: !_ctx.form.startTime,
                                  onSelect: _ctx.handleDurationPicker
                                }, null, 8, ["value", "disabled-hours", "disabled-minutes", "disabled", "onSelect"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "participants" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.t('Meet.Participants')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.form.allParticipants,
                          "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.allParticipants) = $event)),
                          mode: "multiple",
                          "label-in-value": "",
                          placeholder: _ctx.t('Meet.selectParticipants'),
                          style: {"width":"100%"},
                          "filter-option": false,
                          "not-found-content": _ctx.state.fetchingUpdate ? undefined : null,
                          options: _ctx.filteredUsersUpdate,
                          onSearch: _ctx.fetchUserUpdate,
                          onChange: _ctx.handleUsersUpdateSelect
                        }, _createSlots({ _: 2 }, [
                          (_ctx.state.fetchingUpdate)
                            ? {
                                name: "notFoundContent",
                                fn: _withCtx(() => [
                                  _createVNode(_component_a_spin, { size: "small" })
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["value", "placeholder", "not-found-content", "options", "onSearch", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "notifMail" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.t('Meet.notifMailContent')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.form.notifMail,
                          "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.notifMail) = $event)),
                          rows: 4,
                          placeholder: _ctx.t('Meet.notifMailContent')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { class: "periodicty-container" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_107, [
                      _createVNode(_component_a_switch, {
                        checked: _ctx.checkedPeriodicityUpdate,
                        "onUpdate:checked": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.checkedPeriodicityUpdate) = $event)),
                        class: "check-btn"
                      }, null, 8, ["checked"]),
                      _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.t('Meet.periodicity')), 1)
                    ]),
                    (_ctx.checkedPeriodicityUpdate === true)
                      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 9 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_group, {
                                  value: _ctx.periodicity,
                                  "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.periodicity) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "daily",
                                      disabled: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Daily')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "weekly",
                                      disabled: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.weekly')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "monthly",
                                      disabled: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.monthly')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_component_a_radio, {
                                      style: _normalizeStyle(_ctx.radioStyle),
                                      value: "yearly",
                                      disabled: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.annual')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["style"])
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 15 }, {
                              default: _withCtx(() => [
                                (_ctx.periodicity ===  'daily' )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                      _createElementVNode("div", _hoisted_110, [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _ctx.weeklyConfUpdate,
                                          "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.weeklyConfUpdate) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Monday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Monday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Tuesday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Tuesday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Wednesday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Wednesday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Thursday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Thursday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Friday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Friday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Saturday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Saturday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Sunday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Sunday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _createElementVNode("div", _hoisted_111, [
                                        (_ctx.weeklyConfUpdate.length === 7)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(_ctx.t('Meet.MeetingEvery')) + " " + _toDisplayString(_ctx.t('Meet.everyday')), 1))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.t('Meet.MeetingEvery')), 1),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyConfUpdate, (day) => {
                                                return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(_ctx.translateDay(day)) + " , ", 1))
                                              }), 128))
                                            ], 64)),
                                        _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_date_picker, {
                                              value: _ctx.form.periodEndDate,
                                              "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.periodEndDate) = $event)),
                                              class: "period-date",
                                              "disabled-date": _ctx.disablePeriodDates,
                                              disabled: "",
                                              bordered: false
                                            }, null, 8, ["value", "disabled-date"])
                                          ]),
                                          _: 1
                                        }, 8, ["locale"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.periodicity ===  'weekly' )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                      _createElementVNode("div", _hoisted_116, [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.weeklyTxt')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.t('Meet.every')), 1),
                                        _createVNode(_component_a_input, {
                                          value: _ctx.form.periodicity,
                                          "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.periodicity) = $event)),
                                          class: "periodicity-input",
                                          disabled: ""
                                        }, null, 8, ["value"]),
                                        _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.t('Meet.week')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_119, [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _ctx.weeklyConfUpdate,
                                          "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.weeklyConfUpdate) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Monday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Monday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Tuesday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Tuesday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Wednesday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Wednesday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Thursday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Thursday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Friday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Friday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Saturday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Saturday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_row, { class: "days-container" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_checkbox, {
                                                      value: "Sunday",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Sunday')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _createElementVNode("div", _hoisted_120, [
                                        (_ctx.weeklyConfUpdate.length === 7)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(_ctx.t('Meet.MeetingEvery')) + " " + _toDisplayString(_ctx.t('Meet.everyday')), 1))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.t('Meet.MeetingEvery')), 1),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyConfUpdate, (day) => {
                                                return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(_ctx.translateDay(day)) + " , ", 1))
                                              }), 128))
                                            ], 64)),
                                        _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_date_picker, {
                                              value: _ctx.form.periodEndDate,
                                              "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.periodEndDate) = $event)),
                                              class: "period-date",
                                              "disabled-date": _ctx.disablePeriodDates,
                                              disabled: "",
                                              bordered: false
                                            }, null, 8, ["value", "disabled-date"])
                                          ]),
                                          _: 1
                                        }, 8, ["locale"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.periodicity ===  'monthly' )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                      _createElementVNode("div", _hoisted_125, [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.monthlyTxt')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.t('Meet.ofEvery')), 1),
                                        _createVNode(_component_a_input, {
                                          value: _ctx.form.periodicity,
                                          "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.periodicity) = $event)),
                                          class: "periodicity-input",
                                          disabled: ""
                                        }, null, 8, ["value"]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t('Meet.Montly')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_127, [
                                        _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_date_picker, {
                                              value: _ctx.form.periodEndDate,
                                              "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.periodEndDate) = $event)),
                                              class: "period-date",
                                              "disabled-date": _ctx.disablePeriodDates,
                                              disabled: "",
                                              bordered: false
                                            }, null, 8, ["value", "disabled-date"])
                                          ]),
                                          _: 1
                                        }, 8, ["locale"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.periodicity === 'yearly')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                      _createElementVNode("div", _hoisted_130, [
                                        _createVNode(_component_a_tooltip, null, {
                                          title: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('Meet.annualTxt')), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_QuestionCircleOutlined, {
                                              class: _normalizeClass([_ctx.locale === 'ar' ? 'tooltip-icon-rtl' : 'tooltip-icon'])
                                            }, null, 8, ["class"])
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.t('Meet.every')), 1),
                                        _createVNode(_component_a_input, {
                                          value: _ctx.form.periodicity,
                                          "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.periodicity) = $event)),
                                          class: "periodicity-input",
                                          disabled: ""
                                        }, null, 8, ["value"]),
                                        _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.t('Meet.year')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_133, [
                                        _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.t('Meet.until')), 1),
                                        _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_date_picker, {
                                              value: _ctx.form.periodEndDate,
                                              "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.periodEndDate) = $event)),
                                              class: "period-date",
                                              disabled: "",
                                              "disabled-date": _ctx.disablePeriodDates,
                                              bordered: false
                                            }, null, 8, ["value", "disabled-date"])
                                          ]),
                                          _: 1
                                        }, 8, ["locale"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.checkedPeriodicityUpdate === true)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 5 }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "availibility-btn",
                          onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.checkAvailabilityUpdate())),
                          disabled: _ctx.isButtonDisabled
                        }, _toDisplayString(_ctx.t('Meet.CheckAvailibility')), 9, _hoisted_135)
                      ]),
                      _: 1
                    }),
                    (_ctx.state.beginCheck  === true)
                      ? (_openBlock(), _createBlock(_component_a_col, {
                          key: 0,
                          span: 19
                        }, {
                          default: _withCtx(() => [
                            (_ctx.state.periodical===false)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_136, [
                                  _createTextVNode(_toDisplayString(_ctx.t('Meet.periodicalError')) + ", ", 1),
                                  _createElementVNode("span", {
                                    class: "discover-title",
                                    onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.openDiscover && _ctx.openDiscover(...args)))
                                  }, _toDisplayString(_ctx.t('Meet.discover')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.periodical===true && _ctx.state.displaySucees === true )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_137, [
                                  _createVNode(_component_check_circle_two_tone, { "two-tone-color": "#52c41a" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.periodicalSuccess')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.openSlots && _ctx.checkedPeriodicityUpdate === true  && _ctx.state.periodical===false)
              ? (_openBlock(), _createBlock(_component_a_row, {
                  key: 1,
                  gutter: 16
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.AllSlots, (slot, index) => {
                      return (_openBlock(), _createBlock(_component_a_descriptions, {
                        key: index,
                        bordered: "",
                        size: "small",
                        class: _normalizeClass(["mr", [_ctx.locale === 'ar' ? 'ingredient-des-rtl' : 'ingredient-des']])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slot.availability, (availability, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                              _createVNode(_component_a_descriptions_item, {
                                label: _ctx.t('Meet.Date'),
                                span: 3
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(slot.date) + " - " + _toDisplayString(availability.slot), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _createVNode(_component_a_descriptions_item, {
                                label: _ctx.t('Meet.Available')
                              }, {
                                default: _withCtx(() => [
                                  (availability.active === 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_138, [
                                        _createVNode(_component_check_circle_two_tone, { "two-tone-color": "#52c41a" })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (availability.active === 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_139, [
                                        _createVNode(_component_close_circle_two_tone, { "two-tone-color": "#ff4d4f" })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ], 64))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "request-btn",
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.showEquipments(_ctx.form.id)))
                    }, _toDisplayString(_ctx.t('Meet.Equipements')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "request-btn",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.showServices(_ctx.form.id)))
                    }, _toDisplayString(_ctx.t('Meet.Services')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "class"])
      ]),
      _: 1
    }, 8, ["open", "placement", "width", "onClose"]),
    _createVNode(_component_a_modal, {
      open: _ctx.openUserModal,
      "onUpdate:open": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.openUserModal) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_140, [
          _createVNode(_component_a_button, {
            key: "back",
            onClick: _ctx.cancelInviteModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_141, [
          _createVNode(_component_TeamOutlined, { class: "users-icon" }),
          _createElementVNode("p", {
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
          }, [
            _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.t('Meet.InviteParticipant')), 1)
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "inviteFormRef",
          model: _ctx.inviteForm,
          rules: _ctx.usersRules,
          layout: "vertical",
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "users" }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.t('Meet.Participants')), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_144, [
                          _createElementVNode("span", _hoisted_145, _toDisplayString(_ctx.t('Meet.InviteParticipantTxt')), 1)
                        ]),
                        _createVNode(_component_a_select, {
                          value: _ctx.user,
                          "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.user) = $event)),
                          mode: "tags",
                          style: {"width":"100%"},
                          placeholder: _ctx.t('Meet.Participants'),
                          options: _ctx.invitations,
                          onChange: _ctx.handleMultiUserChange
                        }, null, 8, ["value", "placeholder", "options", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "class"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: _ctx.openEqModal,
      "onUpdate:open": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.openEqModal) = $event)),
      onCancel: _ctx.handleCancelEq
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_146, [
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _ctx.addEquipement
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Meet.Confirm')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            key: "back",
            onClick: _ctx.handleCancelEq
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_147, [
          _createElementVNode("p", {
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
          }, [
            _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.t('Meet.Equipements')), 1)
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formEquipmentRef",
          model: _ctx.formEquipment,
          layout: "vertical",
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "equipmenets" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.t('Meet.Equipements')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.form.items_id,
                          "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.items_id) = $event)),
                          mode: "multiple",
                          style: {"width":"100%"},
                          options: _ctx.optionsUpdate,
                          onChange: _ctx.handleUpdateItem,
                          "show-search": ""
                        }, null, 8, ["value", "options", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.newEqArray, (item) => {
              return (_openBlock(), _createBlock(_component_a_row, {
                key: item,
                gutter: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_150, _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: 'qtEq' + item.id,
                        "validate-status": _ctx.getValidatingStatusQT(item.id,'qtEq'),
                        help: _ctx.getValidatingHelpQT(item.id,'qtEq')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            id: 'qtEq' + item.id,
                            value: item.qte,
                            "onUpdate:value": ($event: any) => ((item.qte) = $event),
                            placeholder: _ctx.t('Meet.Quantity'),
                            class: "input-form",
                            disabled: item.oldItem===true
                          }, null, 8, ["id", "value", "onUpdate:value", "placeholder", "disabled"])
                        ]),
                        _: 2
                      }, 1032, ["name", "validate-status", "help"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.itemsArray, (item) => {
              return (_openBlock(), _createBlock(_component_a_row, {
                key: item,
                gutter: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_151, _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { "has-feedback": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: item.qte,
                            "onUpdate:value": ($event: any) => ((item.qte) = $event),
                            placeholder: _ctx.t('Meet.Quantity'),
                            class: "input-form",
                            disabled: item.oldItem===true
                          }, null, 8, ["value", "onUpdate:value", "placeholder", "disabled"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, {
                    span: 6,
                    class: "tag-container"
                  }, {
                    default: _withCtx(() => [
                      (item.approved === 1 )
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: "green"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_check_circle_outlined)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Approved')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.approved=== 0)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "red"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_CloseCircleOutlined)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Disapproved')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["model", "class"])
      ]),
      _: 1
    }, 8, ["open", "onCancel"]),
    _createVNode(_component_a_modal, {
      open: _ctx.openSerModal,
      "onUpdate:open": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.openSerModal) = $event)),
      onCancel: _ctx.handleCancelSer
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_152, [
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _ctx.addService
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Meet.Confirm')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            key: "back",
            onClick: _ctx.handleCancelSer
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_153, [
          _createElementVNode("p", {
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
          }, [
            _createElementVNode("span", _hoisted_154, _toDisplayString(_ctx.t('Meet.Services')), 1)
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formServiceRef",
          model: _ctx.formService,
          layout: "vertical",
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "services" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.t('Meet.Services')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.form.items_id_ser,
                          "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.items_id_ser) = $event)),
                          mode: "multiple",
                          style: {"width":"100%"},
                          options: _ctx.optionsUpdateSer,
                          onChange: _ctx.handleUpdateSer,
                          "show-search": ""
                        }, null, 8, ["value", "options", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.newSerArray, (item) => {
              return (_openBlock(), _createBlock(_component_a_row, {
                key: item,
                gutter: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_156, _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        "has-feedback": "",
                        name: 'qt' + item.id,
                        "validate-status": _ctx.getValidatingStatusQT(item.id,'qt'),
                        help: _ctx.getValidatingHelpQT(item.id,'qt')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            id: 'qt' + item.id,
                            value: item.qte,
                            "onUpdate:value": ($event: any) => ((item.qte) = $event),
                            placeholder: _ctx.t('Meet.Quantity'),
                            class: "input-form",
                            disabled: item.oldItem===true
                          }, null, 8, ["id", "value", "onUpdate:value", "placeholder", "disabled"])
                        ]),
                        _: 2
                      }, 1032, ["name", "validate-status", "help"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, {
                    span: 6,
                    class: "tag-container"
                  }, {
                    default: _withCtx(() => [
                      (item.approved===1 || item.approved===true)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: "red"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_check_circle_outlined)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Approved')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.approved===0 || item.approved===false)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "red"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_CloseCircleOutlined)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Disapproved')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.itemsArraySer, (item) => {
              return (_openBlock(), _createBlock(_component_a_row, {
                key: item,
                gutter: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_157, _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { "has-feedback": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: item.qte,
                            "onUpdate:value": ($event: any) => ((item.qte) = $event),
                            placeholder: _ctx.t('Meet.Quantity'),
                            class: "input-form",
                            disabled: item.oldItem===true
                          }, null, 8, ["value", "onUpdate:value", "placeholder", "disabled"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, {
                    span: 6,
                    class: "tag-container"
                  }, {
                    default: _withCtx(() => [
                      (item.approved===1 || item.approved===true)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: "green"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_check_circle_two_tone, { "two-tone-color": "#52c41a" })
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Approved')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.approved===0 || item.approved===false)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "red"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_CloseCircleOutlined)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_ctx.t('Meet.Disapproved')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["model", "class"])
      ]),
      _: 1
    }, 8, ["open", "onCancel"])
  ], 64))
}